import React from 'react';
import styled from 'styled-components';
import Spinner from '@src/components/common/loading/spinner';

const LoadingContainer = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: calc(var(--vh, 1vh) * 100);
	display: flex;
	justify-content: center;
	align-items: center;
	background: #F5F5F7;
	z-index: 9999;
`;

const GlobalLoading: React.FC = () => (
	<LoadingContainer>
		<Spinner />
	</LoadingContainer>
);

export default GlobalLoading;
